import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';

interface Props {
  items: {
    text?: string;
    textKey?: string;
    link?: string;
    hidden?: boolean;
  }[];
  overridePredefined?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppBreadcrumbs',
  props: {
    items: null,
    overridePredefined: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  items: {
    text?: string;
    textKey?: string;
    link?: string;
    hidden?: boolean;
  }[];
  overridePredefined?: boolean;
};



const predefinedCrumbs = {
  main: { textKey: 'home_page', link: '/' },
};

const crumbs = computed(() => {
  return (
    props.overridePredefined
      ? [...props.items]
      : [{ ...predefinedCrumbs.main }, ...props.items]
  ).filter(({ hidden }) => !hidden);
});

return { __sfc: true,props, predefinedCrumbs, crumbs }
}

})